import { Button, ButtonVariant, Modal } from "shared/components";
import { InfoCircle } from "untitledui-js-base";

export const RevertConditionallyRunModal = ({
  isOpen,
  onClose,
  onSubmit
}: {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}) => {
  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      panelClassName="max-w-[420px] items-center flex flex-col p-6 shadow-lg border border-alpha-100"
    >
      <div className="w-16 h-16 bg-alpha-40 rounded-full flex items-center justify-center">
        <InfoCircle className="stroke-content-400" size="30" />
      </div>

      <div className="text-center space-y-2 mt-6">
        <p className="text-content-1000 font-bold text-xl">
          Conditional report running requires rule-based recommendations
        </p>

        <p className="text-content-400 font-medium text-sm">
          If you select &quot;Don`t recommend decision&quot; or
          &quot;Score-based recommendation&quot; all reports set for conditional
          running will revert to automatic running
        </p>
      </div>

      <div className="flex w-full gap-2 mt-6">
        <Button className="w-full" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant={ButtonVariant.PRIMARY}
          className="w-full"
          onClick={() => onSubmit()}
        >
          Continue
        </Button>
      </div>
    </Modal>
  );
};
